export enum SpaceType {
    Undefined = 0,
    Room = 1,
    Parking = 2,
    Desk = 3
  }